
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnere/[slug]",
      function () {
        return require("private-next-pages/partnere/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnere/[slug]"])
      });
    }
  